import React from "react";
import { useDispatch } from "react-redux";
import {
  setActiveFund,
  setShowAmitMobile,
} from "../../state/actions/DashboardActions";
import { useTranslation } from "react-i18next";
import greenDot from "../../assets/images/green-dot.png";
import greyDot from "../../assets/images/grey-dot.png";
import arrowLeftIcon from "../../assets/images/arrow-left.png";
import { numberWithCommas } from "../../utils/helpers/numberConverter";
import { dateDotFormat } from "../../utils/helpers/dateFormatter";
import AmitCarouselItemProps from "./AmitCarouselItemProps";
import { PENSION_FUND_LABEL_AR, PENSION_FUND_LABEL_HE } from "../../utils/constants/PensionConsts";

import "./AmitCarouselItem.scss";

const AmitCarouselItem = (props: AmitCarouselItemProps) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();

  const fundDesc = () =>{
    return localStorage.getItem("lang") === "he" ? PENSION_FUND_LABEL_HE : PENSION_FUND_LABEL_AR
  }
  const handleClick = () => {
    dispatch(setActiveFund(props.fund));
    dispatch(setShowAmitMobile(true));
  };

  const getTotalRedemption = () => {
    if (props.redemptionData) {
      return numberWithCommas(
        Math.floor(
          props?.redemptionData?.compensationSum +
            props?.redemptionData?.employeeSum +
            props?.redemptionData?.employerSum
        )
      );
    }
  };

  return (
    <>
      <div className="carousel-item-text-wrapper">
        <div className="d-flex align-items-center justify-content-space-between">
          <span className="carousel-item-fund-name">
            {" "}
            {(localStorage.getItem("lang") === "he") ? props.fund.fundLabel : props.fund.fundNameArab}
            {/* {props.fund.fundLabel} */}
            {/* TODO: fundNameArab  */}
          </span>
          <div className="carousel-item-badge-wrapper">
            <img
              src={props.fund.isActiveFund ? greenDot : greyDot}
              alt=""
              width={35}
              height={35}
            />
            <span
              className="carousel-item-icon-text"
              style={{ marginTop: -10 }}
            >
              {props.fund.isActiveFund
                ? t("Sidebar.active")
                : t("Sidebar.notActive")}
            </span>
          </div>
        </div>
        <span className="carousel-item-fund-desc" style={{ marginTop: -15 }}>
          {fundDesc()}
          
        </span>
      </div>
      <div className="carousel-gimlai-middle-wrapper">
        <div className="carousel-gimlai-right-wrapper">
          {props?.pensionData?.accumulatedPensionAmount === null ? (
            <>
              <span className="carousel-item-middle-title">
                {t("Dashboard.pensionPercent")}
              </span>
              <div style={{ marginTop: -10 }}>
                <span className="carousel-item-middle-value">
                  {numberWithCommas(
                    (props?.pensionData?.accumulatedPensionPercent.toFixed(2))
                  ) || 0}
                </span>
                <span className="carousel-item-shekel">%</span>
              </div>
            </>
          ) : (
            <>
              <span className="carousel-item-middle-title">
                {t("Dashboard.sumKitzva")}
              </span>
              <div style={{ marginTop: -10 }}>
                <span className="carousel-item-shekel">₪</span>
                <span className="carousel-item-middle-value">
                  {numberWithCommas(
                    Math.floor(props?.pensionData?.accumulatedPensionAmount)
                  ) || 0}
                </span>
              </div>
            </>
          )}
        </div>
        <div className="carousel-item-left-wrapper">
          <div className="carousel-item-left-details">
            <span style={{ fontWeight: 500, fontSize: "16px" }}>
              {t("general.sum")}
            </span>
            <div className="d-flex align-items-center">
              <span style={{ fontWeight: 500, fontFamily: "Roboto" }}>
                {getTotalRedemption() || 0}
              </span>
              <span style={{ fontWeight: 500, marginRight: 1 }}>₪</span>
            </div>
          </div>
          {props?.pensionData?.accumulatedPensionAmount !== null ? (
            <div
              className="carousel-item-left-details"
              style={{ marginTop: 8 }}
            >
              <span style={{ fontWeight: 500, fontSize: "16px" }}>
                {t("Dashboard.pensionPercent")}
              </span>
              <div className="d-flex align-items-center">
                <span style={{ fontWeight: 500, marginRight: 1 }}>%</span>
                <span style={{ fontWeight: 500, fontFamily: "Roboto" }}>
                  {(props.pensionData?.accumulatedPensionPercent.toFixed(2)) ||
                    0}
                </span>
              </div>
            </div>
          ) : null}
        </div>
      </div>

      {props?.lastDeposit?.depositDate?.length ? (
        <div
          className="carousel-item-bottom-wrapper"
          style={{
            marginTop:
              props?.pensionData?.accumulatedPensionAmount === null ? 45 : '16%',
          }}
        >
          <span>{`${t("Dashboard.lastDeposit")}: ${dateDotFormat(
            props.lastDeposit.depositDate
          )}`}</span>

          <button className="carousel-item-button" onClick={handleClick}>
            <span>{t("general.moreDetails")}</span>
            <img src={arrowLeftIcon} alt="" />
          </button>
        </div>
      ) : (
        <div
          className="carousel-item-bottom-wrapper"
          style={{
            marginTop:
              props?.pensionData?.accumulatedPensionAmount === null ? 45 : '16%',
            justifyContent: "end",
          }}
        >
          <button className="carousel-item-button" onClick={handleClick}>
            <span>{t("general.moreDetails")}</span>
            <img src={arrowLeftIcon} alt="" />
          </button>
        </div>
      )}
    </>
  );
};

export default AmitCarouselItem;
